import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

if (!url || !key) {
  console.warn('Supabase configuration is missing. Copy .env.example to .env before running the PWA.')
}

export const supabase = createClient(url ?? 'https://invalid.local', key ?? 'invalid-key', {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'spence_prechequeo_auth_v1',
  },
})
